import { Action } from '@ngrx/store';

export const GET_HOTEL_MEAL_BASIS = '[Hotel Meal Basis] Get hotel meal basis';
export const GET_HOTEL_MEAL_BASIS_SUCCESS = '[Hotel Meal Basis] Get meal basis success';

export class GetHotelMealBasis implements Action {
  readonly type = GET_HOTEL_MEAL_BASIS;
}

export class GetHotelMealBasisSuccess implements Action {
  readonly type = GET_HOTEL_MEAL_BASIS_SUCCESS;
  constructor(public payload: any) {}
}

export type HotelMealBasisActions = GetHotelMealBasis | GetHotelMealBasisSuccess;
